import { render, staticRenderFns } from "./MedicoView.vue?vue&type=template&id=4caf72a6"
import script from "./MedicoView.vue?vue&type=script&lang=js"
export * from "./MedicoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports